export default "__VITE_ASSET__CZJ2qz$i__"